// project import
import NavCard from "./NavCard";
import Navigation from "./navigation/Navigation";
import SimpleBar from "components/third-party/SimpleBar";

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => (
    <SimpleBar
        sx={{
            "& .simplebar-content": {
                display: "flex",
                flexDirection: "column",
                background: "rgb(22,32,90)",
                height: "100%",
            },
        }}
    >
        <Navigation />
    </SimpleBar>
);

export default DrawerContent;
